import { Component, OnInit, Input } from '@angular/core';
import { Email } from '../../security/user/email.model';

@Component({
  selector: 'app-usuario-email-list',
  templateUrl: './usuario-email-list.component.html',
  styleUrls: ['./usuario-email-list.component.scss']
})
export class UsuarioEmailListComponent implements OnInit {
  @Input() email: Email;
  @Input() emails: Email[];
  constructor() { }

  ngOnInit() {
  }

  onlyOneEmailPrincipal() {
    for (const email of this.emails){
      if (email.principal === true) {
        email.principal = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-email-list/usuario-email-list.component.ts